export interface CalendarPalette {
  /** Sekcijos fonas */
  sectionBg: string
  /** Kortelės (mėnesio, datos) fonas */
  cardBg: string
  cardBorder: string
  /** Antraštės ir mėnesio pavadinimo spalva */
  heading: string
  /** Neaktyvios dienos / pagalbinis tekstas */
  muted: string
  /** Užsiėmimo dienos langelis */
  activeBg: string
  activeText: string
  /** Akcentai — skirtukai, taškai, ikonos */
  accent: string
  badgeBg: string
  badgeText: string
}

/**
 * Violetinė gama, derinama su pagrindinio puslapio indigo / levandos / magenta
 * banerio spalvomis. Artėjantis kursas jos nenaudoja — jis lieka baltai
 * rožinis su auksu.
 */
export const futurePalette: CalendarPalette = {
  sectionBg: '#F3EBFC',
  cardBg: '#FFFFFF',
  cardBorder: '#E0CFF4',
  heading: '#2B1055',
  muted: '#9585B0',
  activeBg: '#7209B7',
  activeText: '#FFFFFF',
  accent: '#7209B7',
  badgeBg: '#E9DBF8',
  badgeText: '#4B0B7A',
}

export const pastPalette: CalendarPalette = {
  sectionBg: '#F8F6FB',
  cardBg: '#FFFFFF',
  cardBorder: '#E8E2F1',
  heading: '#4C4460',
  muted: '#ABA2BC',
  activeBg: '#D8CBE9',
  activeText: '#413456',
  accent: '#C2B4D8',
  badgeBg: '#EFEAF7',
  badgeText: '#5A4E70',
}
